import { AgencyAPI } from "generated-api"
import { checkIfSessionIsOrWillExpired } from "user/tools/common"
import { IAgency, IAgencyCurrentBalance, IAgencyRepository, IShortAgency } from "./model"

export const agencyRPO: IAgencyRepository = {
  getAllAgencies(): Promise<IAgency[]> {
    return new Promise<IAgency[]>((resolve, reject) => {
      try {
        checkIfSessionIsOrWillExpired()
        AgencyAPI.getApiAgencyList()
          .then(response => resolve(response))
          .catch((error: any) => {
            console.error("Server error while getting all agencies", error)
            reject("agency.get.all.error.server")
          })
      } catch (ex) {
        console.error("Unexpected error while getting all agencies", ex)
        reject("agency.get.all.error.unexpected")
      }
    })
  },
  getAvailableAgencies(): Promise<IShortAgency[]> {
    return new Promise<IShortAgency[]>((resolve, reject) => {
      try {
        checkIfSessionIsOrWillExpired()
        AgencyAPI.getApiAgencyListAvailable()
          .then(response => resolve(response))
          .catch((error: any) => {
            console.error("Server error while getting available agencies", error)
            reject("agency.get.available.error.server")
          })
      } catch (ex) {
        console.error("Unexpected error while getting available agencies", ex)
        reject("agency.get.available.error.unexpected")
      }
    })
  },
  getAgencyCurrentBalance(agencyId: number): Promise<IAgencyCurrentBalance> {
    return new Promise<IAgencyCurrentBalance>((resolve, reject) => {
      try {
        checkIfSessionIsOrWillExpired()
        AgencyAPI.getApiAgencyCurrentBalance(agencyId)
          .then(response => resolve(response as IAgencyCurrentBalance))
          .catch((error: any) => {
            console.error("Server error while getting agency current balance", error)
            reject("agency.get.agency.balance.error.server")
          })
      } catch (ex) {
        console.error("Unexpected error while getting agency current balance", ex)
        reject("agency.get.agency.balance.error.unexpected")
      }
    })
  }
}
